export default "__VITE_ASSET__CSZV6$dL__"